export default __webpack_public_path__ + "static/kohinoor-cdcd65629d9cf4b2e1c40a3c3e56fdd9.svg";